export default __webpack_public_path__ + "static/media/tradeKartIcon.f0ba706e.svg";